import { styled } from 'styled-components';

export const FieldPlaceholder = styled.div`
  display: flex;
  height: 36px;
  align-items: center;
`;
